import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

// project-imports
import BarChannelLogo, { type BarChannelLogoVariant } from './BarChannelLogo';
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';

interface Props {
  isIcon?: boolean;
  variant?: BarChannelLogoVariant;
  sx?: SystemStyleObject<Theme>;
  to?: To;
}

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ isIcon, variant, sx, to }: Readonly<Props>) {
  const { isLoggedIn } = useAuth();
  const linkTo = to ?? APP_DEFAULT_PATH;
  const logoVariant = variant ?? (isIcon ? 'sidebar-mini' : 'sidebar-expanded');

  return (
    <ButtonBase
      disableRipple
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: logoVariant === 'sidebar-mini' ? 'center' : 'flex-start',
        width: '100%',
        py: 0.5
      }}
      {...(isLoggedIn && { component: Link, to: linkTo })}
    >
      <BarChannelLogo variant={logoVariant} sx={sx} />
    </ButtonBase>
  );
}
